import { FC } from 'react'
import { useHistory } from 'react-router-dom'

import CONFIG from '../../../config'
import { Title, Text, Button, Icon } from '../../components/UI'

type AdminUserFormSuccessProps = {
  type?: 'CREATE' | 'EDIT' | 'VALIDATE',
  title?: string,
  buttonText?: string,
  wrapper?: boolean,
  onClick?(): void
}

const AdminUserFormSuccess:FC<AdminUserFormSuccessProps> = ({ children, type = 'CREATE', title = '¡Registro exitoso!', buttonText = 'VOLVER AL ADMINISTRADOR', wrapper = false, onClick })  => {
  const history = useHistory()

  return (
    <div className="text-center pt-40 pb-50 px-15">
      <Icon name="modal-success" />
      <Title component="h4" size="20" weight="bold" className="mt-20">{title}</Title>
      <div className={`mt-20 ${wrapper ? 'register-form-modal-wrapper' : ''}`}>
        <Text lineHeight="6">{children}</Text>
      </div>
      {type === 'CREATE' && <Button className="mt-30" onClick={onClick}>REGISTRAR OTRO USUARIO</Button>}
      <Button className="mt-25" onClick={() => history.push(CONFIG.ROUTES.ADMIN.USERS.HOME)}>{buttonText}</Button>
    </div>
  )
}

export { AdminUserFormSuccess }